import { useCallback } from 'react';

import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import type { Channel } from './types';

export function useGetShareTrackingData(): ShareActionsOptions<Channel>['getTrackingData'] {
	return useCallback(
		(channel) => ({
			location: channel,
			view_context: 'news_show',
		}),
		[],
	);
}
